import moment from "moment";
import _ from "lodash";
import CryptoJS from "crypto-js";

import {
  USER_ROLES,
  COLORS,
  DATE_FORMAT,
  TIME_FORMAT,
  DATE_TIME_FORMAT,
  EMPTY_STRING,
  CONFIGURATION_MAPPING_FIELDS,
  ENCRYTION_DECRYPTION_KEY,
  LOAN_APPLICATION_CATEGORY,
} from "./Constants";
import { APPLICATION_CONFIGURATIONS } from "./ApplicationConfigurations";

let countries = require("i18n-iso-countries");

if (APPLICATION_CONFIGURATIONS.applicationLanguage === "es") {
  countries.registerLocale(require("i18n-iso-countries/langs/es.json"));
} else {
  countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
}

export default class Utility {
  /**
   * This function will return localization id for application status
   * @param {*} status -application status
   */
  static getLocalizationIdForApplicationStatus(status) {
    let id;
    switch (status) {
      case LOAN_APPLICATION_CATEGORY.active:
        id = "active";
        break;
      case LOAN_APPLICATION_CATEGORY.legal:
        id = "legal";
        break;
      case LOAN_APPLICATION_CATEGORY.writeOff:
        id = "writeOff";
        break;
      case LOAN_APPLICATION_CATEGORY.closed:
        id = "closed";
        break;
      default:
        id = "default";
        break;
    }
    return id;
  }

  /**
   * This function will return localization id for user role
   * @param {*} role -user role
   */
  static getLocalizationIdForUserRole(role) {
    let id;
    switch (role) {
      case USER_ROLES.admin:
        id = "admin";
        break;
      case USER_ROLES.general_manager:
        id = "general_manager";
        break;
      case USER_ROLES.analyst:
        id = "analyst";
        break;
      case USER_ROLES.analyst_moderator:
        id = "analyst_moderator";
        break;
      case USER_ROLES.operations_officer:
        id = "operations_officer";
        break;
      case USER_ROLES.cashier:
        id = "cashier";
        break;
      case USER_ROLES.cashier_moderator:
        id = "cashier_moderator";
        break;
      case USER_ROLES.customer_care:
        id = "customer_care";
        break;
      case USER_ROLES.client:
        id = "client";
        break;
      case USER_ROLES.configurator:
        id = "configurator";
        break;
      case USER_ROLES.loan_portfolio_manager:
        id = "loan_portfolio_manager";
        break;
      case USER_ROLES.collections_officer:
        id = "collections_officer";
        break;
      case USER_ROLES.collections_moderator:
        id = "collections_moderator";
        break;
      default:
        id = "admin";
    }
    return id;
  }

  /**
   * This function will return localization id for month
   * @param {*} month -a number
   */
  static getLocalizationIdForMonth(month) {
    let id;
    switch (month) {
      case 1:
        id = "january";
        break;
      case 2:
        id = "february";
        break;
      case 3:
        id = "march";
        break;
      case 4:
        id = "april";
        break;
      case 5:
        id = "may";
        break;
      case 6:
        id = "june";
        break;
      case 7:
        id = "july";
        break;
      case 8:
        id = "august";
        break;
      case 9:
        id = "september";
        break;
      case 10:
        id = "october";
        break;
      case 11:
        id = "november";
        break;
      case 12:
        id = "december";
        break;
      default:
        id = "";
        break;
    }
    return id;
  }

  static getSpanishStringForMonth(month) {
    let monthString;
    switch (month) {
      case 1:
        monthString = "Enero";
        break;
      case 2:
        monthString = "febrero";
        break;
      case 3:
        monthString = "Marzo";
        break;
      case 4:
        monthString = "Abril";
        break;
      case 5:
        monthString = "Mayo";
        break;
      case 6:
        monthString = "Junio";
        break;
      case 7:
        monthString = "Julio";
        break;
      case 8:
        monthString = "Agosto";
        break;
      case 9:
        monthString = "Septiembre";
        break;
      case 10:
        monthString = "Octubre";
        break;
      case 11:
        monthString = "Noviembre";
        break;
      case 12:
        monthString = "Diciembre";
        break;
      default:
        monthString = "";
        break;
    }
    return monthString;
  }

  /**
   * This function will return color value for accepted status
   * @param {*} status -status of application
   */
  static getColourValueForApplicationStatus(status) {
    let colourValue;
    switch (status) {
      case "ACTIVE":
        colourValue = COLORS.green;
        break;
      case "LEGAL":
        colourValue = COLORS.lightGreen;
        break;
      case "W_OFF":
        colourValue = COLORS.lightBlue;
        break;
      case "CLOSED":
        colourValue = COLORS.orange;
        break;

      default:
        colourValue = COLORS.lightGreen;
        break;
    }
    return colourValue;
  }

  /**
   *
   *
   */

  // static getLocalizationIdForField(fieldValue) {
  //   switch (fieldValue) {
  //     case CONFIGURATION_MAPPING_FIELDS.birthDate:
  //       return {Strings("birthDate" />;
  //     case CONFIGURATION_MAPPING_FIELDS.country:
  //       return {Strings("country" />;
  //     case CONFIGURATION_MAPPING_FIELDS.stayInSpain:
  //       return {Strings("stayInSpain" />;
  //     case CONFIGURATION_MAPPING_FIELDS.employmentSituation:
  //       return {Strings("employmentSituation" />;
  //     case CONFIGURATION_MAPPING_FIELDS.jobTime:
  //       return {Strings("jobTime" />;
  //     case CONFIGURATION_MAPPING_FIELDS.totalIncome:
  //       return {Strings("totalIncome" />;
  //     case CONFIGURATION_MAPPING_FIELDS.paymentTotalIncome:
  //       return {Strings("paymentTotalIncome" />;
  //     case CONFIGURATION_MAPPING_FIELDS.paymentIncomeMinusExpenses:
  //       return {Strings("paymentIncomeMinusExpenses" />;
  //     case CONFIGURATION_MAPPING_FIELDS.paymentOtherLoan:
  //       return {Strings("paymentOtherLoan" />;
  //     case CONFIGURATION_MAPPING_FIELDS.addressValidation:
  //       return {Strings("addressValidation" />;
  //     case CONFIGURATION_MAPPING_FIELDS.validationByReference:
  //       return {Strings("validationByReference" />;
  //     case CONFIGURATION_MAPPING_FIELDS.reference1Validation:
  //       return {Strings("reference1Validation" />;
  //     case CONFIGURATION_MAPPING_FIELDS.reference2Validation:
  //       return {Strings("reference2Validation" />;
  //   }
  // }

  static getLocalizationIdForField(fieldValue) {
    switch (fieldValue) {
      case CONFIGURATION_MAPPING_FIELDS.birthDate:
        return "birthDate";
      case CONFIGURATION_MAPPING_FIELDS.country:
        return "country";
      case CONFIGURATION_MAPPING_FIELDS.stayInSpain:
        return "stayInSpain";
      case CONFIGURATION_MAPPING_FIELDS.employmentSituation:
        return "employmentSituation";
      case CONFIGURATION_MAPPING_FIELDS.jobTime:
        return "jobTime";
      case CONFIGURATION_MAPPING_FIELDS.totalIncome:
        return "totalIncome";
      case CONFIGURATION_MAPPING_FIELDS.paymentTotalIncome:
        return "paymentTotalIncome";
      case CONFIGURATION_MAPPING_FIELDS.paymentIncomeMinusExpenses:
        return "paymentIncomeMinusExpenses";
      case CONFIGURATION_MAPPING_FIELDS.paymentOtherLoan:
        return "paymentOtherLoan";
      case CONFIGURATION_MAPPING_FIELDS.addressValidation:
        return "addressValidation";
      case CONFIGURATION_MAPPING_FIELDS.validationByReference:
        return "validationByReference";
      case CONFIGURATION_MAPPING_FIELDS.reference1Validation:
        return "reference1Validation";
      case CONFIGURATION_MAPPING_FIELDS.reference2Validation:
        return "reference2Validation";
      case CONFIGURATION_MAPPING_FIELDS.annualCountOfTransaction:
        return "annualCountOfTransaction";
      case CONFIGURATION_MAPPING_FIELDS.annualAmountSentOrTransferred:
        return "annualAmountSentOrTransferred";
      case CONFIGURATION_MAPPING_FIELDS.yearsAsAnEurophileClient:
        return "yearsAsAnEurophileClient";
      case CONFIGURATION_MAPPING_FIELDS.beneficiaryRelationship:
        return "beneficiaryRelationship";
      case CONFIGURATION_MAPPING_FIELDS.last5YearsBehaviorCurve:
        return "last5YearsBehaviorCurve";
      default:
        return EMPTY_STRING;
    }
  }

  /**
   * This function will convert dateTime into simple date time format
   * @param {*} dateTime -date format returned by server
   */
  static getFormattedDateTime(dateTime) {
    let dateComponent = moment(dateTime).format(DATE_FORMAT);
    let timeComponent = moment(dateTime).format(TIME_FORMAT);
    return {
      date: dateComponent,
      time: timeComponent,
    };
  }

  /**
   * This function will convert dateTime into formatted string
   * @param {*} dateTime -date format returned by server
   */
  static getFormattedDateString(dateTime) {
    return moment(dateTime).format(DATE_TIME_FORMAT);
  }

  /**
   * This function will return current month aand year as object
   */
  static getCurrentMonthYear() {
    let date = new Date();
    let currentMonth = moment(date).get("month") + 1;
    let currentYear = moment(date).get("year");
    currentMonth = currentMonth < 10 ? "0" + currentMonth : currentMonth;
    return {
      currentMonth: currentMonth,
      currentYear: currentYear,
    };
  }

  /**
   * This function will return month and year by substracting monthCount from date.
   * @param {*} date -date object
   * @param {*} monthCount -number of months to substract
   */
  static getPreviousMonthYear(date, monthCount) {
    let obj = moment(date).subtract(monthCount, "months");
    let previousMonth = moment(obj).get("month") + 1;
    let previousYear = moment(obj).get("year");
    previousMonth = previousMonth < 10 ? "0" + previousMonth : previousMonth;
    return {
      previousMonth: previousMonth,
      previousYear: previousYear,
    };
  }
  /**
   * This function will return set of month and year values (count=monthCount) before passed value of month and year.
   * @param {*} month -month value in number
   * @param {*} year -year value
   * @param {*} monthCount -Total of months in set
   */
  static getPreviousMonthsSet(month, year, monthCount) {
    let previousMonthYears = [];
    let dateObject = new Date(year, month, 1, 0, 0, 0, 0);
    for (let i = 0; i < monthCount; i++) {
      previousMonthYears.push({
        month:
          Utility.getPreviousMonthYear(dateObject, i).previousMonth - 1 === 0
            ? 12
            : Utility.getPreviousMonthYear(dateObject, i).previousMonth - 1,
        year: Utility.getPreviousMonthYear(dateObject, i).previousYear,
      });
    }
    return previousMonthYears;
  }

  /**
   * This function will return object from data with same month and year, null if not found.
   * @param {*} data -array of json
   * @param {*} month -month value
   * @param {*} year -year value
   */
  static getObjectWithSameYearMonth(data, month, year) {
    let objectWithSameYearMonth = null;
    data.forEach((singleMonthData) => {
      if (singleMonthData.month === month && singleMonthData.year === year) {
        objectWithSameYearMonth = singleMonthData;
      }
    });
    return objectWithSameYearMonth;
  }

  /**
   *
   * @param {*} amountRequested -Selected amount
   * @param {*} months -Selected month
   * @param {*} repaymentCalculationInformation -Repayment information used for EMI calculation.
   */
  static getEMIDetailsForSelectedMonthAmount(
    amountRequested,
    months,
    repaymentCalculationInformation
  ) {
    let objectIndex = _.findIndex(
      repaymentCalculationInformation.loanAmount,
      function (obj) {
        return obj.amount === Utility.getIntegerValue(amountRequested);
      }
    );
    let selectedAmountObject =
      repaymentCalculationInformation.loanAmount[objectIndex];
    let emiValueObjectIndex = _.findIndex(
      selectedAmountObject.emiDetails,
      function (obj) {
        return obj.month === Utility.getIntegerValue(months);
      }
    );

    return selectedAmountObject.emiDetails[emiValueObjectIndex];
  }

  /**
   * Get object of min max amount based on selected loan index
   * @param {*} repaymentCalculationInformation - Repayment Calculation Information
   * @param {*} loanIndex -Selected Loan Index
   */
  static getMinMaxAmountObject = (
    repaymentCalculationInformation,
    loanIndex
  ) => {
    let objectMinMaxAmt = {};

    _.each(repaymentCalculationInformation.minMaxAmt, (minMaxAmtObject) => {
      if (minMaxAmtObject.index === loanIndex) {
        objectMinMaxAmt = {
          minAmount: minMaxAmtObject.minAmt,
          maxAmount: minMaxAmtObject.maxAmt,
          amountStepper: repaymentCalculationInformation.amountStepper,
        };
        return false;
      }
    });

    return objectMinMaxAmt;
  };

  /**
   * This function will convert passed value to integer
   */
  static getIntegerValue(value) {
    let integerValue;
    integerValue = parseInt(value, 10);
    return integerValue;
  }

  /**
   * This function will return country code of country name
   */
  static getCountryCode(countryName) {
    let code;
    code = countries.getAlpha3Code(
      countryName,
      APPLICATION_CONFIGURATIONS.applicationLanguage
    );
    return code;
  }

  /**
   * This function will return country name from country code
   */
  static getCountryName(countryCode) {
    let name;
    name = countries.getName(
      countryCode,
      APPLICATION_CONFIGURATIONS.applicationLanguage
    );
    return name;
  }

  static getDecryptedData = (encryptString) => {
    try {
      const parsedBase64Key = CryptoJS.enc.Base64.parse(
        ENCRYTION_DECRYPTION_KEY
      );
      const decryptedData = CryptoJS.AES.decrypt(
        encryptString,
        parsedBase64Key,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        }
      );

      return decryptedData.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.log("error:", e.message);
    }
  };
  static getCurrencyRepresentationOfAmount = (nStr) => {
    nStr += "";
    let x = nStr.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "," + x[1] : "";
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1.$2");
    }
    return x1 + x2;
  };
}
